<template>
    <p>
        {{ date }}
    </p>
    <p>
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
        {{ userStore.user.address }}
        <br />
        {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
    </p>
    <p>
        {{ creditor.creditor_name }}
        <br />
        <template v-if="creditor.address">
            {{ creditor.address }}
        </template>
        <template v-else>
            {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
        </template>
    </p>
    <p class="letter-content" style="text-align: center;">
        Notice to Agent is Notice to Principal, Notice to Principal is Notice to Agent 
    </p>
    <p class="letter-content">
        {{ creditor.creditor_name }} you replied that the alleged transaction that you identified as late is validated. You have no proof that this alleged transaction was late. 
    </p>
    <p class="letter-content">
        15 U.S. Code § 1666b - Timing of payments
    </p>
    <p class="letter-content">
        (a)Time to Make Payments
    </p>
    <p class="letter-content">
        A creditor may not treat a payment on a credit card account under an open end consumer credit plan as late for any purpose, unless the creditor has adopted reasonable procedures designed to ensure that each periodic statement including the information required by section 1637(b) of this title is mailed or delivered to the consumer not later than 21 days before the payment due date.
    </p>
    <p class="letter-content">
        In order for any creditor to treat a payment as late you must prove that:
    </p>
    <p class="letter-content">
        1)The information required under 15 USC 1637(b) of this title was mailed out or delivered 21 Days before the payment due date please provide the proof that this information was mailed out or delivered 21 days before the statement date.
    </p>
    <p class="letter-content">
        20 15 USC 1637(b) is very specific on all required information needed or that must be mailed or delivered to the consumer! You have 10 days to send me all the required information.
    </p>
    <p>
        Sincerely,
        <br />
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
    </p>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>
